import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PagesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pages"}/>
}
